/* tr-theme.js — Vanilla JS, kein CDN, kein jQuery. */
(function () {
  'use strict';

  var FAV_KEY = 'tr-fav';
  var CMP_KEY = 'tr-compare';
  var VIEW_KEY = 'tr-recent';
  var DAY = 864e5;

  function load(key) {
    try {
      var raw = localStorage.getItem(key);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function save(key, val) {
    try {
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) {
      /* quota / private mode — still, no PII */
    }
  }

  function prune(list) {
    var now = Date.now();
    return (list || []).filter(function (item) {
      return item && item.id && now - (item.ts || 0) < 30 * DAY;
    });
  }

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  /* Menu parts from sibling header-group sections into the drawer slot */
  function relocateMenuParts() {
    var slot = $('#tr-menue-slot');
    if (!slot) return;
    $all('[data-tr-menue-part]').forEach(function (el) {
      if (!slot.contains(el)) slot.appendChild(el);
    });
  }

  function bindDrawer() {
    var drawer = $('#tr-menue-drawer');
    if (!drawer) return;
    $all('[data-tr-open-menu]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
      });
    });
    $all('[data-tr-close-menu]', drawer).forEach(function (btn) {
      btn.addEventListener('click', function () {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
      });
    });
    $all('[data-tr-menue-level]').forEach(function (level) {
      /* drill-down: show panel by id */
    });
    $all('[data-tr-drill]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-tr-drill');
        $all('[data-tr-menue-level]').forEach(function (p) {
          p.hidden = p.getAttribute('data-tr-menue-level') !== id;
        });
      });
    });
    $all('[data-tr-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-tr-back') || 'root';
        $all('[data-tr-menue-level]').forEach(function (p) {
          p.hidden = p.getAttribute('data-tr-menue-level') !== id;
        });
      });
    });
  }

  /* Service hours 8–18. Weekdays unspecified in the brief — every local day. */
  function bindPhoneStatus() {
    $all('[data-tr-service]').forEach(function (el) {
      var hour = parseInt(new Date().toLocaleString('de-DE', { timeZone: 'Europe/Berlin', hour: 'numeric', hour12: false }), 10);
      var start = parseInt(el.getAttribute('data-hour-start') || '8', 10);
      var end = parseInt(el.getAttribute('data-hour-end') || '18', 10);
      var open = hour >= start && hour < end;
      el.setAttribute('data-open', open ? '1' : '0');
      var slot = el.querySelector('[data-tr-service-state]');
      if (slot) slot.textContent = open ? '' : '';
    });
  }

  function bindFavorites() {
    var list = prune(load(FAV_KEY));
    save(FAV_KEY, list);
    function ids() {
      return list.map(function (x) { return String(x.id); });
    }
    function syncButtons() {
      var on = ids();
      $all('[data-tr-fav]').forEach(function (btn) {
        var id = btn.getAttribute('data-tr-fav');
        btn.classList.toggle('is-on', on.indexOf(id) !== -1);
        btn.setAttribute('aria-pressed', on.indexOf(id) !== -1 ? 'true' : 'false');
      });
      var count = $('#tr-fav-count');
      if (count) count.textContent = String(list.length);
    }
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest && ev.target.closest('[data-tr-fav]');
      if (!btn) return;
      ev.preventDefault();
      var id = btn.getAttribute('data-tr-fav');
      if (!id) return;
      var i = ids().indexOf(id);
      if (i === -1) list.push({ id: id, ts: Date.now() });
      else list.splice(i, 1);
      list = prune(list);
      save(FAV_KEY, list);
      syncButtons();
    });
    syncButtons();
  }

  function bindCompare() {
    var list = prune(load(CMP_KEY));
    save(CMP_KEY, list);
    function ids() {
      return list.map(function (x) { return String(x.id); });
    }
    function sync() {
      var on = ids();
      $all('[data-tr-compare]').forEach(function (btn) {
        var id = btn.getAttribute('data-tr-compare');
        btn.classList.toggle('is-on', on.indexOf(id) !== -1);
      });
      var bar = $('#tr-compare-bar');
      if (bar) {
        bar.classList.toggle('is-on', list.length >= 2);
        var n = bar.querySelector('[data-tr-compare-count]');
        if (n) n.textContent = String(list.length);
      }
    }
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest && ev.target.closest('[data-tr-compare]');
      if (!btn) return;
      ev.preventDefault();
      var id = btn.getAttribute('data-tr-compare');
      if (!id) return;
      var i = ids().indexOf(id);
      if (i === -1) list.push({ id: id, ts: Date.now() });
      else list.splice(i, 1);
      list = prune(list);
      save(CMP_KEY, list);
      sync();
    });
    sync();
  }

  function bindRecent() {
    var el = $('[data-tr-recent-id]');
    if (!el) return;
    var id = el.getAttribute('data-tr-recent-id');
    if (!id) return;
    var list = prune(load(VIEW_KEY)).filter(function (x) { return String(x.id) !== id; });
    list.unshift({ id: id, ts: Date.now() });
    save(VIEW_KEY, list.slice(0, 12));
  }

  function bindGallery() {
    $all('[data-tr-galerie]').forEach(function (root) {
      var main = root.querySelector('[data-tr-galerie-main]');
      $all('[data-tr-thumb]', root).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-src');
          if (main && src) {
            var img = main.querySelector('img');
            if (img) img.src = src;
          }
        });
      });
    });
  }

  /* B12 + E4: Galerie-Video auf Klick, nie Autoplay, preload=none. */
  function bindVideoKlick() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest && ev.target.closest('[data-tr-video-klick]');
      if (!btn) return;
      var src = btn.getAttribute('data-src');
      var galerie = btn.closest('[data-tr-galerie]');
      var slot = galerie && galerie.querySelector('[data-tr-video-slot]');
      if (!src || !slot) return;
      slot.hidden = false;
      slot.innerHTML = '';
      var v = document.createElement('video');
      v.src = src;
      v.controls = true;
      v.preload = 'none';
      slot.appendChild(v);
      v.play();
    });
  }

  function bindAudio() {
    $all('[data-tr-audio]').forEach(function (root) {
      var btn = root.querySelector('[data-tr-audio-toggle]');
      var audio = root.querySelector('audio');
      if (!btn || !audio) return;
      btn.addEventListener('click', function () {
        if (audio.paused) audio.play();
        else audio.pause();
      });
    });
  }

  function bindAktionsleiste() {
    $all('[data-tr-aktion-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = panel.hidden;
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function bindFilters() {
    $all('[data-tr-filter]').forEach(function (root) {
      var apply = root.querySelector('[data-tr-filter-apply]');
      if (!apply) return;
      apply.addEventListener('click', function () {
        var url = new URL(window.location.href);
        $all('[data-tr-chip].is-on', root).forEach(function (chip) {
          var key = chip.getAttribute('data-key');
          var val = chip.getAttribute('data-value');
          if (key && val) url.searchParams.append('filter.p.m.tr.' + key, val);
        });
        window.location.href = url.toString();
      });
      $all('[data-tr-chip]', root).forEach(function (chip) {
        chip.addEventListener('click', function () {
          chip.classList.toggle('is-on');
        });
      });
    });
  }

  /* Predictive search is Dawn's component; this only focuses the always-on field. */
  function bindSearch() {
    $all('[data-tr-focus-search]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = document.getElementById('tr-search-input');
        if (input) input.focus();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    relocateMenuParts();
    bindDrawer();
    bindPhoneStatus();
    bindFavorites();
    bindCompare();
    bindRecent();
    bindGallery();
    bindVideoKlick();
    bindAudio();
    bindAktionsleiste();
    bindFilters();
    bindSearch();
  });
})();
